import React from 'react'
import { Popover, Box, Button } from '@mui/material'
import { Plus, CloudArrowUp } from 'phosphor-react'

export default function AddBulkAddButtons({
    openButtonPopover,
    handleButtonPopoverClose,
    openNewModal,
    openImportModal,
    trackableType,
    newLabel,
    option2,
}) {
    const displayLabel = newLabel || `New ${trackableType}`;

    return (
        <Popover
            id={Boolean(openButtonPopover) ? "simple-popover" : undefined}
            open={Boolean(openButtonPopover)}
            anchorEl={openButtonPopover}
            onClose={handleButtonPopoverClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    border: "none",
                    marginTop: "8px",
                    boxShadow: "0px 0px 4px 0px #00000040",
                },
            }}
        >
            <Box sx={{
                width: "max-content",
                backgroundColor: "#252A38",
                boxShadow: "0px 0px 4px 0px #00000040",
                borderRadius: "10px",
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                justifyContent: "center",
                gap: "10px",
            }}>
                <Button
                    fullWidth
                    size="small"
                    sx={{
                        backgroundColor: "#6C65D9",
                        height: "40px",
                        borderRadius: "10px",
                        fontSize: "14px",
                        padding: "8px 12px",
                        color: "#EEEEEE",
                        textTransform: "none",
                        justifyContent: "flex-start",
                        "&:hover": { backgroundColor: "#5a54c4" },
                    }}
                    disableElevation
                    onClick={() => {
                        openNewModal();
                        handleButtonPopoverClose();
                    }}
                    startIcon={<Plus size={18} />}
                >
                    {displayLabel}
                </Button>
                {trackableType === "shot" && (
                    <Button
                        fullWidth
                        size="small"
                        sx={{
                            backgroundColor: "#6C65D9",
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            padding: "8px 12px",
                            color: "#EEEEEE",
                            textTransform: "none",
                            justifyContent: "flex-start",
                            "&:hover": { backgroundColor: "#5a54c4" },
                        }}
                        disableElevation
                        onClick={() => {
                            option2();
                            handleButtonPopoverClose();
                        }}
                        startIcon={<Plus size={18} />}
                    >
                        Multiple shots
                    </Button>
                )}
                <Button
                    fullWidth
                    size="small"
                    sx={{
                        backgroundColor: "transparent",
                        height: "40px",
                        borderRadius: "10px",
                        fontSize: "14px",
                        padding: "8px 12px",
                        color: "#EEEEEE",
                        border: "2px solid #6C65D9",
                        textTransform: "none",
                        justifyContent: "flex-start",
                        "&:hover": { backgroundColor: "#252A38", borderColor: "#5a54c4" },
                    }}
                    disableElevation
                    onClick={() => {
                        openImportModal();
                        handleButtonPopoverClose();
                    }}
                    startIcon={<CloudArrowUp size={18} />}
                >
                    Bulk Import
                </Button>
            </Box>
        </Popover>
    )
}